import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Flex, Switch } from '@zillow/constellation';
import UnenrollModal from './UnenrollModal';
import useQueryVariables from '../../../hooks/useQueryVariables';
import {
  emitEnrollmentToggleDisableEvent,
  emitEnrollmentToggleEnableEvent,
} from '../../../../client/analytics/clickstreamEvents';
import { useListingUser } from '../../../hooks/useListingUser';

export default function EnrollmentSwitch({ enrollmentOn, setEnrollmentStatus }) {
  const [unenrollModalOn, setUnenrollModalOn] = useState(false);
  const { propertyId } = useQueryVariables();
  const { user, listing } = useListingUser();

  function toggleEnrollmentSwitch() {
    if (enrollmentOn) {
      setUnenrollModalOn(true);
    } else {
      setEnrollmentStatus({
        applicationsAccepted: true,
        propertyId,
      });
    }

    if (enrollmentOn) {
      emitEnrollmentToggleDisableEvent(listing, user);
    } else {
      emitEnrollmentToggleEnableEvent(listing, user);
    }
  }

  useEffect(() => {
    if (!enrollmentOn) {
      setUnenrollModalOn(false);
    }
  }, [enrollmentOn]);

  return (
    <>
      <UnenrollModal
        unenrollModalOn={unenrollModalOn}
        closeUnenrollModal={() => setUnenrollModalOn(false)}
        setEnrollmentStatus={setEnrollmentStatus}
      />
      <Flex>
        <Switch
          size="lg"
          checkbox={
            <Checkbox
              aria-label="toggle application enrollment"
              checked={enrollmentOn}
              onClick={toggleEnrollmentSwitch}
            />
          }
        />
      </Flex>
    </>
  );
}

EnrollmentSwitch.propTypes = {
  enrollmentOn: PropTypes.bool,
  setEnrollmentStatus: PropTypes.func.isRequired,
};
